import { EventToolbox } from 'client/utils/event-toolbox';
import { STEP_SUBMITTED_WITH_ERRORS } from 'site-modules/shared/constants/appraisal/events';

export const fireStepSubmittedWithErrorsEvent = details => {
  EventToolbox.fireCustomEvent(STEP_SUBMITTED_WITH_ERRORS, details);
};
